import React from 'react';
import { Users, Database, Bot, Workflow } from 'lucide-react';
import { mockServices } from '../mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const iconMap = {
  Users: Users,
  Database: Database,
  Bot: Bot,
  Workflow: Workflow
};

export const ServicesGrid = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [gridRef, gridVisible] = useScrollAnimation();
  
  return (
    <section className="services-section" id="services">
      <div className="section-container">
        <div 
          ref={headerRef}
          className={`section-header ${headerVisible ? 'animate-fade-in-up' : ''}`}
        >
          <h2 className="section-title">Services That Scale</h2>
          <p className="section-subtitle">
            Enterprise solutions built with cutting-edge automation technology
          </p>
        </div>
        
        <div ref={gridRef} className="bento-grid">
          {mockServices.map((service, index) => {
            const Icon = iconMap[service.icon];
            const delay = index * 150;
            return (
              <div 
                key={service.id} 
                className={`bento-card ${index === 0 ? 'bento-card-large' : ''} ${gridVisible ? 'animate-scale-in' : ''}`}
                style={{ animationDelay: gridVisible ? `${delay}ms` : '0ms', opacity: gridVisible ? 1 : 0 }}
              >
                <div className="bento-card-inner">
                  <div className="bento-icon-wrapper">
                    <Icon className="bento-icon" size={40} />
                  </div>
                  
                  <h3 className="bento-title">{service.title}</h3>
                  <p className="bento-description">{service.description}</p>
                  
                  <div className="bento-glow"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
